export { Badge } from "@mantine/core";
export * from "./Badge.config";
